module.exports = __webpack_public_path__ + "images/help/icn-faq-wechat-ba053ea532fdee6b38eac2b9840d6fbd.png";